import { render, staticRenderFns } from "./SideExtendedPanel.vue?vue&type=template&id=557434ed&"
import script from "./SideExtendedPanel.vue?vue&type=script&lang=js&"
export * from "./SideExtendedPanel.vue?vue&type=script&lang=js&"
import style0 from "./SideExtendedPanel.vue?vue&type=style&index=0&id=557434ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports